<form [formGroup]="form">
    <div>
        @if (value$ | async; as current) {

            @if (!isOrderDisabled || current.value !== 0) {

                @if (current.value === 0 && showAddToCartButton) {
                    <div class="has-text-centered">
                        <button (click)="increase()" class="button cart is-primary mt-0">
                            In den Warenkorb
                        </button>
                    </div>
                }

                @if (!showAddToCartButton || current.value !== 0) {
                    <div class="is-flex">
                        <div (click)="decrease()" class="button minus is-light px-3 mr-2 is-flex-grow-1">
                            @if (current.value === 1) {
                                <fa-icon [icon]="icons.faTrash" role="img" [attr.aria-label]="article.name + ' entfernen'"></fa-icon>
                            } @else {
                                <fa-icon [icon]="icons.faMinus" role="img" [attr.aria-label]="'Menge reduzieren'"></fa-icon>
                            }
                        </div>

                        <input #inputEl type="number" class="input amount pl-2 pr-1 has-text-centered is-flex-grow-1"
                               (change)="change($event)" formControlName="amount" min="0">

                        <div (click)="increase()" class="button plus is-primary px-3 ml-2 is-flex-grow-1">
                            <fa-icon [icon]="icons.faPlus" role="img" [attr.aria-label]="'Menge erhöhen'"></fa-icon>
                        </div>
                    </div>
                }
            }

            @if (isOrderDisabled && current.value === 0) {
                <div>
                    @if(currentAvailabilityConfig?.isInquiry){
                        <div class="is-flex">
                            <div>
                                <fa-icon [icon]="icons.faInfo"
                                         class="is-size-4 tooltip mt-1 mr-1"
                                         [pTooltip]="currentAvailabilityConfig?.cartOverrideText || 'NICHT BESTELLBAR'"
                                         tooltipPosition="top"></fa-icon>
                            </div>
                            <div class="is-flex-grow-1">
                                <button class="button cart is-secondary not-available"
                                        (click)="showArticleInquiryOverlay = true">
                                    {{ currentAvailabilityConfig?.inquiryOverrideText || 'ANFRAGEN' }}
                                </button>
                            </div>
                        </div>
                    }
                    @if(!currentAvailabilityConfig?.isInquiry){
                        <span class="not-available">{{ currentAvailabilityConfig?.cartOverrideText || 'NICHT BESTELLBAR' }}</span>
                    }
                </div>
            }
            <p-popover #op>
                <div class="has-text-black">
                    <iw-shop-article-price-quantity-discount-button
                            [article]="article"
                            [quantityNetPriceLessThan]="discountLessThan">
                    </iw-shop-article-price-quantity-discount-button>
                </div>
                <div class="mt-2">
                    {{ current.value }} Artikel im Warenkorb.
                    <a routerLink="/cart" class="is-block">Zum Warenkorb <fa-icon [icon]="icons.faShoppingBag"></fa-icon></a>
                </div>
            </p-popover>
        }
    </div>
</form>

@if (showArticleInquiryOverlay) {
    <div class="has-text-left modal is-active">
        <div class="modal-background" (click)="showArticleInquiryOverlay = false"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Artikelanfrage</p>
                <button (click)="showArticleInquiryOverlay = false" class="delete"></button>
            </header>
            <section class="modal-card-body">
                <iw-shop-contact-dynamic
                        [email_subject]="'Anfrage: ' + article.articleNumber"
                        [require_terms_acceptance]="false"
                        [fields]="fieldsForInquiry">
                </iw-shop-contact-dynamic>
            </section>
        </div>
    </div>
}
